import { render, staticRenderFns } from "./criarAtividadeDialog.vue?vue&type=template&id=7a9bbcb4"
import script from "./criarAtividadeDialog.vue?vue&type=script&lang=js"
export * from "./criarAtividadeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports